import { Logger, type RoleId, type RoleData, type RoleListInput, type TinyRole } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { type RoleList } from '../types'
import { roleKey, roleListKey } from '../keys'

const logger = new Logger('useRoleCache')

// logger.level = 'verbose'

export function useRoleCache() {
  const queryClient = useQueryClient()

  const clearItem = (roleId: RoleId): void => {
    logger.verbose('invalidateQueries roleKey', roleId)
    queryClient.invalidateQueries({ queryKey: roleKey(roleId) })
  }

  return {
    clearItem,
    clearList: (props: RoleListInput = {}) => {
      logger.verbose('invalidateQueries roleListKey', props)
      queryClient.invalidateQueries({ queryKey: roleListKey(props) })
    },
    getItem: (roleId: RoleId): RoleData | undefined => {
      logger.verbose('get roleKey', roleId)
      return queryClient.getQueryData<RoleList>(roleListKey({}))?.find((t) => roleId === t.roleId)
    },
    findTinyRole: (roleId: RoleId): TinyRole | undefined => {
      const lists = queryClient.getQueriesData<RoleData[]>({ queryKey: ['roles'] })
      for (const [, roles] of lists) {
        const role = roles?.find((item) => item.roleId === roleId)
        if (!role) continue
        return { roleId: role.roleId, name: role.name, roleType: role.roleType }
      }
    },
  }
}
